<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  .license-info {
    display: flex;
    flex-direction: column;
    flex: 1;
    .license-title {
      font-weight: 600;
      margin-bottom: utils.in_rem(4px);
    }

    .license-status {
      font-size: 0.875rem;
      color: colors.get(interfaceSwGrey_20);
    }
    .license-status.disabled {
      color: colors.get(systemError_100);
    }
  }
</style>

<script>
  import { SIGN_IN_LICENSES } from "../stores";

  let { mod, available, remaining, disabled } = $props();
</script>

<div class="license-info">
  <div class="license-title">
    {mod.title}
    {#if !SIGN_IN_LICENSES.includes(mod.kind)}
      *
    {/if}
  </div>
  <div class="license-status" class:disabled>
    {#if disabled}
      No licenses remaining
    {:else if available}
      {remaining} licenses remaining
    {:else}
      Currently assigned
    {/if}
  </div>
</div>
